import axios from 'axios';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/blog/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/blog/';

class BlogService {

  getAll(size = 999999) {
    return axios.get(API_URL,{params: {size}});
  }
  postBlogEntry(entry) {
    return axios.post(API_URL,entry);
  }
  putBlogEntry(entry) {
    return axios.put(API_URL+entry.id,entry);
  }
  deleteBlogEntry(id) {
    return axios.delete(API_URL+id);
  }
}

export default new BlogService();
